export default __webpack_public_path__ + "static/13-b16569f0d892da49bd1e675e91878646.png";